// extracted by mini-css-extract-plugin
module.exports = {"numbers":"Numbers_numbers__VCNak","numbers__list":"Numbers_numbers__list__Kt1r8","numbers__item":"Numbers_numbers__item__jOkwe"};